// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"6c0056a0","727":"a4e37c15","843":"c356b231","940":"e53eb8fe"}[chunkId] + ".css";
};